import React from "react";
import { assetsPath } from "../../../../../utils";

export default ({ currentLang, selectedType, selectedBuilding }) => {
  const BG = `${assetsPath(
    "laguna-beachside"
  )}/images/site-plan/${currentLang}/r.jpg`;
  const shouldDisplayByLang = (selectLang) => {
    return currentLang === selectLang ? "display" : "display-none";
  };

  const shouldDisplay = (build, type) => {
    return selectedBuilding === build || selectedBuilding === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  // const shouldDisplay = (build) => {
  //   return selectedBuilding === build ? "opacity-in" : "opacity-out";
  // };
  console.log("xxxxxxxxx", { currentLang, selectedType, selectedBuilding });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 841.89 595.28"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        {/* <polygon
          className={shouldDisplay("a")}
          points="631.96 336.59 729.52 341.71 729.02 351.4 760.89 353.09 762.89 321.53 764.83 321.4 766.33 293.96 725.21 291.81 725.58 286.49 693.74 284.84 692.55 306.93 681.96 306.37 683.17 284.03 641.36 281.84 641.14 287.74 609.96 286.15 608.83 305.84 607.99 325.31 632.52 326.59 631.96 336.59"
          fill="#231f20"
          opacity="0.8"
        />
        <polyline
          className={shouldDisplay("b")}
          points="608.92 305.87 608.61 314.59 586.42 309.46 583.58 321.96 572.24 319.37 570.49 327.24 456.39 301.46 457.43 297.12 437.43 292.53 437.18 292.21 435.27 291.74 428.8 290.96 428.86 291.18 413.68 289.12 412.77 295.74 402.49 294.4 402.39 295.28 381.33 292.37 380.83 296.4 349.18 292.03 353.58 259.46 357.55 230.87 389.11 235.25 388.8 237.75 429.49 243.18 428.96 247.43 439.52 248.87 440.8 243.65 481.55 252.93 480.74 256.5 511.21 263.4 510.11 268.43 520.36 270.71 521.52 265.71 551.92 272.65 552.74 269.15 593.52 278.37 588.42 301.21 608.83 305.84"
          fill="#231f20"
          opacity="0.8"
        /> */}
        <polygon
          id="_3"
          className={shouldDisplay("c")}
          data-name="3"
          points="349.69 289.26 350.82 280.73 328.6 280.73 328.64 232.12 286.86 232.15 286.83 254.5 279.05 254.56 279.05 232.37 237.86 232.15 237.86 229.56 205.96 229.56 205.99 251.65 198.24 251.75 198.21 232.18 156.4 232.21 156.43 254.53 148.65 254.59 148.61 232.15 107.58 232.12 107.55 229.5 75.64 229.56 75.61 256.87 82.46 256.9 82.43 275.84 99.46 275.84 99.43 291.37 130.61 291.43 130.58 294.24 162.58 294.28 162.58 273.25 170.33 273.25 170.33 291.43 201.52 291.43 201.55 294.28 233.43 294.31 233.46 285.9 265.55 285.96 265.49 294.24 297.52 294.34 297.49 291.43 328.64 291.46 328.64 289.31 349.69 289.26"
          fill="#231f20"
          opacity="0.8"
        />
        <polyline
          id="_2"
          className={shouldDisplay("b")}
          data-name="2"
          points="608.92 305.87 608.61 314.59 586.42 309.46 583.58 321.96 572.24 319.37 570.49 327.24 456.39 301.46 457.43 297.12 437.43 292.53 437.18 292.21 435.27 291.74 428.8 290.96 428.86 291.18 413.68 289.12 412.77 295.74 402.49 294.4 402.39 295.28 381.33 292.37 380.83 296.4 349.18 292.03 353.58 259.46 357.55 230.87 389.11 235.25 388.8 237.75 429.49 243.18 428.96 247.43 439.52 248.87 440.8 243.65 481.55 252.93 480.74 256.5 511.21 263.4 510.11 268.43 520.36 270.71 521.52 265.71 551.92 272.65 552.74 269.15 593.52 278.37 588.42 301.21 608.83 305.84"
          fill="#231f20"
          opacity="0.8"
        />
        <polygon
          id="_1"
          className={shouldDisplay("a")}
          data-name="1"
          points="631.96 336.59 729.52 341.71 729.02 351.4 760.89 353.09 762.89 321.53 764.83 321.4 766.33 293.96 725.21 291.81 725.58 286.49 693.74 284.84 692.55 306.93 681.96 306.37 683.17 284.03 641.36 281.84 641.14 287.74 609.96 286.15 608.83 305.84 607.99 325.31 632.52 326.59 631.96 336.59"
          fill="#231f20"
          opacity="0.8"
        />
        <polygon
          id="_4"
          className={shouldDisplay("d")}
          data-name="4"
          points="428.91 295.92 428.91 290.88 435.47 291.84 437.46 292.28 437.46 328.14 460.93 328.14 460.93 359.43 464.35 359.43 464.35 391.28 460.95 391.28 460.95 421.7 464.35 421.7 464.35 453.67 460.95 453.67 460.95 484.82 447.14 484.82 447.14 489.84 429.19 493.35 405.82 493.35 405.82 428.92 422.93 428.92 422.93 405.18 406.08 405.18 406.08 378.79 422.93 378.79 422.93 364.14 405.82 364.14 405.82 320.88 428.89 320.88 428.91 295.92"
          fill="#231f20"
          opacity="0"
        />
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/LagunaBeachside/sitePlan/svg/floor/roof.js